import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><g fill="#2e3436"><path d="M8 2A8 8 0 00.262 8.01 8 8 0 008 14a8 8 0 007.738-6.01A8 8 0 008 2zm0 2a4 4 0 014 4 4 4 0 01-4 4 4 4 0 01-4-4 4 4 0 014-4z" style={{
        marker: "none"
      }} /><path d="M10 8a2 2 0 01-2 2 2 2 0 01-2-2 2 2 0 012-2 2 2 0 012 2z" /></g></svg>;
}

export default SvgComponent;